import { GridMain } from '@/components/UI/Grid';
import { Box, IconButton, styled, TableCell } from '@mui/material';

import { TitleTypography } from '../../components/UI/Typography';

export const GridMainContainer = styled(GridMain)(() => ({
  overflow: 'auto',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  height: '100%',
  minHeight: 0,

  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const Title = styled(TitleTypography)(() => ({
  '&.MuiTooltip-tooltip': {
    maxWidth: 'none',
  },
}));

export const TableDataHeader = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  marginBottom: '16px',

  '& .table-row-body': {
    cursor: 'pointer',

    '&:hover': {
      opacity: 0.8,
      transition: '0.3s',
      backgroundColor: '#47546710',
    },
  },
}));

export const GridContainer = styled(Box)(() => ({}));

export const LastSectionCell = styled(TableCell)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));

export const RoundedGreen = styled(Box)(({ theme }) => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: theme.palette.secondary.main,
}));

export const CellWithWarning = styled(TableCell)(() => ({
  borderBottom: '1px solid #E3E3E3',
  '& div': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  },

  '& svg': {
    alignItems: 'flex-end !important',
    color: '#FFD113',
  },
}));

export const BackButton = styled(IconButton)(({ theme }) => ({
  margin: '-20px 0 -10px -30px',

  '& span': {
    fontSize: 40,
    color: theme.palette.secondary.main,
  },
}));

export const StyledTitle = styled(Title)(({ theme }) => ({
  marginTop: '24px',
  textTransform: 'unset',

  '.panel-settings': {
    color: theme.palette.secondary.main,
  },

  '& .arrow-forward-ios': {
    fontSize: '16px',
    color: '#2E383F',
  },

  '& span': {
    fontWeight: 500,
    color: '#2E383F',
  },
}));

export const CardContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '24px',
  marginTop: '32px',
}));

export const Section = styled('section')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '32px 0',

  '& .values': {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
}));
